<div class="row">
    <div class="col">
            <h6 class="font-weight-lighter f-18 cursor-default">{{ 'orgtemplatelist.header' | trans }}</h6>
            <p class="cursor-default font-weight-light">{{ 'orgtemplatelist.subheader' | trans }}</p>
        </div>
</div>
<div *ngFor="let template of templateList" class="row hover-row" (click)="setTemplate(template)">
  <div data-toggle="modal" data-target="#detailsTemplateModal"  class="col">
      <p class="lh-40 mb-0 align-middle font-weight-light cursor-pointer" style="margin-left:5px;" >{{ template.title }}</p>
  </div>
  <div data-toggle="modal" data-target="#detailsTemplateModal" class="col">
      <p class="lh-40 mb-0 align-middle cursor-pointer" style="text-align: center;">{{ 'orgtemplatelist.state' | trans }}{{ template.templatestate }}</p>
  </div>
  <div data-toggle="modal" data-target="#detailsTemplateModal" class="col">
      <p class="lh-40 mb-0 align-middle cursor-pointer" style="text-align: center;">{{ 'orgtemplatelist.created' | trans }}{{ template.created | date: 'yyyy-MM-dd'}}</p>
  </div>
  <div class="col">
      <span data-toggle="modal" data-target="#deleteTemplateModal" 
      matTooltip="{{ 'orgtemplatelist.delete' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
       class="material-icons rounded-circle lh-40 align-middle zoom w-40 pl-2 text-center cursor-pointer opacity-reverse float-right">
          delete
          </span>                
  </div>
</div>

  <!-- DELETE Modal -->
  <div class="modal fade" id="deleteTemplateModal" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgtemplatelist.delete' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p style="text-align: center;">{{ 'orgtemplatelist.confirmdelete' | trans }}{{ choosenTemplate.title }}</p>

          <div class="row">
              <div class="col">
                <button type="button" class="btn-close float-left" data-dismiss="modal"><h6 class="btn-save-text">{{ 'orgtemplatelist.close' | trans }}</h6></button>
            </div>
              <div class="col">
                <button (click)="deleteTemplate()" data-dismiss="modal" type="button" class="btn-save float-right"><h6 class="btn-save-text">{{ 'orgtemplatelist.deletebutton' | trans }}</h6></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Show details Modal -->
  <div class="modal fade" id="detailsTemplateModal" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ 'orgtemplatelist.templatedetails' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ 'orgtemplatelist.titlemodal' | trans }}{{ choosenTemplate.title }}</p>

          <p>{{ 'orgtemplatelist.descriptionmodal' | trans }}{{ choosenTemplate.templatedescription }}</p>

          <p>{{ 'orgtemplatelist.recipemodal' | trans }}{{ choosenTemplate.recipe }}</p>

          <div class="row">
              <div class="col">
                <button type="button" class="btn-close" data-dismiss="modal"><h6 class="btn-save-text">{{ 'orgtemplatelist.close' | trans }}</h6></button>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  </div>